import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import 'leaflet/dist/leaflet.css';
import "./styles/legio2-timeline.css";
import "./styles/legions-timeline.css";

function RootFrame() {
  return (
    <div className="min-h-screen bg-[#0b1220] text-white antialiased">
      <App />
    </div>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RootFrame />
  </React.StrictMode>
)
